import { createContext } from 'react';
import { ReactNode, useCallback } from 'react';
import { useEffect, useState } from 'react';
import { useMapVisibility } from 'app/agriculture/hooks/useMapVisibility/useMapVisibility';

export enum MapMode {
    Overview,
    Notes,
    Tasks,
    Herds,
    Search,
    Devices,
}

interface MapModeContextType {
    mapMode: keyof typeof MapMode;
    setMapMode: (value: keyof typeof MapMode) => void;
}

export const MapModeContext = createContext<MapModeContextType>({} as MapModeContextType);

function getInitialMapMode(): keyof typeof MapMode {
    if (window.location.pathname.includes('notes')) {
        return 'Notes';
    } else if (window.location.pathname.includes('herds')) {
        return 'Herds';
    } else if (window.location.pathname.includes('tasks')) {
        return 'Tasks';
    } else if (window.location.pathname.includes('devices')) {
        return 'Devices';
    }
    return 'Overview';
}

export const MapModeContextProvider = ({ children }: { children: ReactNode }) => {
    const [mapMode, setMapMode] = useState<keyof typeof MapMode>(getInitialMapMode());
    const { toggleMapModeFiltering } = useMapVisibility();
    useEffect(() => {
        toggleMapModeFiltering(mapMode);
    }, []);
    const setMapModeAndToggleVisibility = useCallback((value: keyof typeof MapMode) => {
        toggleMapModeFiltering(value);
        setMapMode(value);
    }, []);

    return (
        <MapModeContext.Provider value={{ mapMode, setMapMode: setMapModeAndToggleVisibility }}>
            {children}
        </MapModeContext.Provider>
    );
};
